const HyperLinkCell = (params: any) => {
    return (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
            {params.value}
        </a>
    );
}

export default HyperLinkCell;